import React from "react";

export const LoadingIndicator: React.FC = () => {
  return (
    <div className="message-container ai-message-container">
      <div className="message ai-message loading-message">
        <div className="loading-spinner"></div>
        <span>KI denkt nach...</span>
      </div>
    </div>
  );
};
